import React, { FC } from 'react';
import { ButtonProp } from '@types';
import { StyledButton } from './ButtonV2.styled';
import { logUserEvent } from '@analytics/amplifyLogging';
import { useSelector } from 'react-redux';
import { selectSelectedLoanNumber } from '@store/selectors/widgets.selectors';

const ButtonV2: FC<ButtonProp> = (props: ButtonProp) => {
    const { identifier } = useSelector(selectSelectedLoanNumber);
    const handleClick = () => {
        if (props?.eventAttributes) {
            logUserEvent({
                type: props.eventAttributes.type,
                description: props.eventAttributes.description,
                action: props.eventAttributes.action,
                loanNumber: identifier
            });
        }
        props.onClick();
    };
    return (
        <StyledButton {...props} onClick={handleClick} role="button">
            {props.text || 'Button'}
        </StyledButton>
    );
};

export default React.memo(ButtonV2);
